var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'button')?_c('v-btn',_vm._b({attrs:{"loading":_vm.loading,"color":"error"},on:{"click":_vm.logout}},'v-btn',_vm.$attrs,false),[_c('v-icon',{staticClass:"mr-1",attrs:{"dark":""}},[_vm._v("exit_to_app")]),_vm._v(" Logout ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }